import { render, staticRenderFns } from "./PreviewSwiper.vue?vue&type=template&id=530db3e4&scoped=true&"
import script from "./PreviewSwiper.vue?vue&type=script&lang=js&"
export * from "./PreviewSwiper.vue?vue&type=script&lang=js&"
import style0 from "./PreviewSwiper.vue?vue&type=style&index=0&id=530db3e4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530db3e4",
  null
  
)

export default component.exports